import { render, staticRenderFns } from "./files-input.vue?vue&type=template&id=0158f391&"
import script from "./files-input.vue?vue&type=script&lang=js&"
export * from "./files-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports